import React from 'react';
import * as _ from 'lodash';
// eslint-disable-next-line no-unused-vars
import parts from '../../../utilities/parts';

import { FieldTreeService } from '../../../services/FieldTrees';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import { FormElement, FormDropdownRadio } from '../../CommonFormComponents';
import Tippy from '../../ReactTippy';
import { isIPad } from '../../../utilities/commonUtil';
import { isNullOrEmpty } from '../../../utilities/stringUtil';
import { messageUtility } from '../../../utilities/messageUtility';

import { QuestionIcon } from '../../icons/QuestionIcon';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';

/**
 * @description 協力会社ドロップダウン
 *              作業、実績、ゲート、揚重機、機材予定登録、編集画面で使用
 */
export class FieldTreePartnerCompanyDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldId: SessionStorageService.getFieldId(), // 現場ID
      loaded: false, // ページング用ロードフラグ
      allLoaded: false,
      initializeLoaded: false, // 編集画面用初回ロードフラグ
      opened: false, // 開閉フラグ
      dateTo: this.props.dateTo || null,
      options: [], // 取得協力会社情報
      // 検索条件協力会社名
      condition: {
        name: '',
      },
      page: 0, // offset用
      selected: null, // 選択協力会社情報(id)
      selectedName: '', // 選択協力会社情報(name)
      temporarySelected: null, // 選択協力会社情報temp(id)
      temporarySelectedName: '', // 選択協力会社情報temp(id)
      isLoading: true, // ロード中フラグ
    };

    this.id = Math.floor(Math.random() * 100000);
    this.targetId = `infinityscroll-target-branch-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.getFieldTreeOperatableIds = this.getFieldTreeOperatableIds.bind(this);
    this.clearIfSelectedNotExists = this.clearIfSelectedNotExists.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.handleInview = this.handleInview.bind(this);
    this.setValue = this.setValue.bind(this);
    this.searchTimer;
  }

  componentDidMount() {
    // 編集時は、まだdateToが入っていないため、ここでは実行しない。
    if (!this.props.isEdit) {
      this.getFieldTreeOperatableIds();
    }
  }

  componentWillReceiveProps(nextProps) {
    // 日付が変更された場合
    if (
      !nextProps.dateTo ||
      _.toString(nextProps.dateTo) !== _.toString(this.state.dateTo)
    ) {
      const doClearCheck = nextProps.dateTo && this.state.dateTo;
      const newState = _.cloneDeep(this.state);
      newState.loaded = false;
      newState.allLoaded = false;
      newState.page = 0;
      newState.dateTo = nextProps.dateTo;
      this.setState(newState, async () => {
        if (doClearCheck) {
          await this.clearIfSelectedNotExists();
        }
      });
    }

    if (_.toString(nextProps.value) !== _.toString(this.state.selected)) {
      // valueに値がある場合のみnameもセット(valueが空でもnameが空にならない)
      const isSetValue = !isNullOrEmpty(nextProps.value);
      this.setState(
        {
          selected: isSetValue ? nextProps.value : null,
          selectedName: isSetValue ? nextProps.name : '',
          temporarySelected: isSetValue ? nextProps.value : null,
          temporarySelectedName: isSetValue ? nextProps.name : '',
        },
        () => {
          this.props.validate('field_tree_id', {
            field_tree_id: this.state.selected,
          });
        }
      );
    }
  }

  componentDidUpdate() {
    if (this.state.opened === true) {
      // コンポーネントが可視状態の場合、clickイベントをセット
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.opened === false) {
      // コンポーネントが不可視状態の場合、clickイベントを削除
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });

    // フォーカスアウト時のバリデーション
    if (this.props.validate) {
      this.props.validate('field_tree_id');
    }
  };

  handleOpen = () => {
    // 初期化
    let { opened, selected, selectedName, loaded } = { ...this.state };
    if (opened === false) {
      // プルダウンを表示した際、temporarySelectedに選択済みのidを入れる
      this.setState({
        opened: true,
        loaded: true,
        temporarySelected: selected,
        temporarySelectedName: selectedName,
      });
      if (!loaded) {
        this.getFieldTreeOperatableIds();
      }
    } else {
      this.setState({ opened: false });
      // フォーカスアウト時のバリデーション
      if (this.props.validate) {
        this.props.validate('field_tree_id');
      }
    }
  };

  /**
   * @description 検索する協力会社名を設定
   * @param {object} events 協力会社名input
   */
  setCondition = events => {
    let condition = { ...this.state.condition };
    condition.name = events.target.value;
    this.setState({ condition });

    clearTimeout(this.searchTimer);
    if (events) {
      this.searchTimer = setTimeout(() => {
        this.search();
      }, 1000);
    }
  };

  /**
   * @description 協力会社を検索
   */
  search = () => {
    this.setState(
      {
        options: [],
        loaded: false,
        allLoaded: false,
        page: 0,
        isLoading: true,
      },
      () => {
        this.getFieldTreeOperatableIds();
      }
    );
  };

  handleInview() {
    if (this.state.loaded && !this.state.allLoaded) {
      this.setState({
        loaded: false,
      });
      this.getFieldTreeOperatableIds();
    }
  }

  /**
   * 選択肢をクリック
   * @param id {int}
   * @param checked {bool} 選択・未選択判定
   */
  handleSelectedRow = (id, checked) => {
    let { temporarySelected, temporarySelectedName } = { ...this.state };
    if (checked === true) {
      // 選択済みの協力会社情報のみselectedRowへ
      temporarySelected = id;
      const selectedRow = _.find(this.state.options, { field_tree_id: id });
      // 選択した協力会社の名前をtempへ
      temporarySelectedName = selectedRow.name;
    } else {
      temporarySelected = null;
      temporarySelectedName = '';
    }

    this.setState(
      {
        temporarySelected,
        temporarySelectedName,
      },
      () => {
        this.setValue();
      }
    );
  };

  /**
   * 「選択」押下時
   */
  setValue = () => {
    let { selected, selectedName, opened } = { ...this.state };
    // temp情報をselect~に入れる
    selected = this.state.temporarySelected;
    selectedName = this.state.temporarySelectedName;
    this.setState(
      {
        selected,
        selectedName,
        opened: !opened,
      },
      () => {
        this.props.set('field_tree_id', selected);
        if (this.props.validate) {
          this.props.validate('field_tree_id', { field_tree_id: selected });
        }
      }
    );
  };

  /**
   * @description 協力会社情報取得
   */
  async getFieldTreeOperatableIds() {
    if (this.state.loaded) {
      this.setState({ isLoading: false });
      return;
    }

    const params = {
      field_id: this.state.fieldId,
      name: this.state.condition.name,
      limit: REQUEST_PARAMS.parentLimit,
      offset: this.state.page * REQUEST_PARAMS.parentLimit,
      work_hour_zone: SessionStorageService.getWorkHourZone(),
      date_to: this.state.dateTo,
    };

    const doApi = async () => {
      FieldTreeService.selectableCompaniesList(this.state.fieldId, params).then(
        response => {
          if (response.result === false) {
            this.setState({ isLoading: false });
            return;
          }
          const companiesWithfieldTreeIds = _.assign(
            response.data.entities.companies
          );
          const allLoaded = _.size(companiesWithfieldTreeIds) < 1;
          let options = _.cloneDeep(this.state.options);
          if (this.state.page === 0) {
            options = [];
          }

          // 1件目のみ取得されたとき自動セットを防ぐ
          // 編集モードの場合は値がなくても自動セットしない(移行データの場合のみ施工体系図から削除済みで表示され協力会社がnullとなるため)
          if (
            _.size(companiesWithfieldTreeIds) === 1 &&
            _.size(options) === 0 &&
            (isNullOrEmpty(this.state.selected) && !this.props.isEdit)
          ) {
            const firstCompany = companiesWithfieldTreeIds[0];
            this.setState(
              {
                selected: firstCompany.field_tree_id,
                selectedName: firstCompany.name,
              },
              () => {
                this.props.set('field_tree_id', firstCompany.field_tree_id);
                this.props.validate('field_tree_id', {
                  field_tree_id: this.state.selected,
                });
              }
            );
          }

          _.each(companiesWithfieldTreeIds, tree => {
            if (_.findIndex(options, { id: tree.field_tree_id }) < 0) {
              options.push(tree);
            }
          });

          this.setState({
            options,
            loaded: true,
            allLoaded,
            page: this.state.page + 1,
            isLoading: false,
          });
        }
      );
    };
    await doApi();
  }

  /**
   * 選択値がリストにない場合はクリアする
   */
  async clearIfSelectedNotExists() {
    if (!this.state.selected) {
      return;
    }

    const params = {
      field_id: this.state.fieldId,
      limit: 30,
      offset: 0,
      work_hour_zone: SessionStorageService.getWorkHourZone(),
      date_to: this.state.dateTo,
      field_tree_id: this.state.selected,
    };

    await FieldTreeService.selectableCompaniesList(
      this.state.fieldId,
      params
    ).then(response => {
      if (response.result === false) {
        return;
      }

      const companies = response.data.entities.companies;
      if (_.size(companies) < 1) {
        this.setState(
          {
            selected: null,
            selectedName: '',
          },
          () => {
            this.props.set('field_tree_id', null);
            this.props.validate('field_tree_id', {
              field_tree_id: this.state.selected,
            });
          }
        );
      }
    });
  }

  render() {
    const getName = () => {
      let name = '協力会社を選択';
      const option = _.find(this.state.options, {
        id: this.state.selected,
      });
      if (!_.isUndefined(option)) {
        name = option.name;
      } else {
        name = this.state.selectedName || name;
      }
      return name;
    };

    if (this.props.isFormListDefault && this.props.readOnly) {
      return (
        <FormElement>
          <div>{getName()}</div>
        </FormElement>
      );
    }
    return (
      <FormElement validate={this.props.error}>
        <div className='form-dropdown dropdown-multi-select'>
          {this.props.readOnly ? (
            <input disabled type='text' value={getName()} />
          ) : (
            <div ref={this.parent}>
              <div
                className={`dropdown-multi-select__header ${
                  this.state.opened ? 'show' : ''
                }`}
              >
                {isIPad() ? (
                  // iPad の場合 ツールチップの動作がおかしいため
                  // コントロールの幅を大きく(300px)する
                  // 指定しない場合は 165px
                  <div
                    id='form-dropdown-btn'
                    href=''
                    className='dropdown-select'
                    onClick={this.handleOpen}
                  >
                    <span className='dropdown-select__txt'>{getName()}</span>
                  </div>
                ) : (
                  <Tippy
                    duration={10}
                    multiple={false}
                    arrow={true}
                    arrowType='sharp'
                    placement='bottom'
                    maxWidth='160px'
                    html={renderTooltipContent(getName())}
                  >
                    <div
                      id='form-dropdown-btn'
                      href=''
                      className='dropdown-select'
                      onClick={this.handleOpen}
                    >
                      <span className='dropdown-select__txt'>{getName()}</span>
                    </div>
                  </Tippy>
                )}
              </div>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              {this.state.opened && (
                <div
                  id='form-dropdown-list'
                  className='dropdown dropdown--dropdown-list show'
                >
                  <div className='dropdown__item dropdown__item--wide dropdown__item--hidden'>
                    <div className='dropdown-single-select__item'>
                      <i className='i-search i-2x' />
                      <input
                        type='text'
                        placeholder={messageUtility.getMessage('I-000-090')}
                        defaultValue={this.state.condition.name}
                        onChange={this.setCondition}
                      />
                    </div>
                    <div className='dropdown-single-select__item'>
                      <div
                        className='dropdown-single-select__scroll'
                        id={this.targetId}
                      >
                        <ul className='single-select'>
                          {_.map(this.state.options, (option, index) => (
                            <FormDropdownRadio
                              key={index}
                              indexKey={index}
                              option={option}
                              checked={
                                this.state.temporarySelected ===
                                option.field_tree_id
                              }
                              targetId={option.field_tree_id}
                              handleSelectedRow={this.handleSelectedRow}
                              forId='single-field-tree-operatable-id'
                              column='field_tree_id'
                            >
                              {option.name}
                            </FormDropdownRadio>
                          ))}
                          <InfinityScrollLoad
                            targetId={this.targetId}
                            total={_.size(this.state.options)}
                            isLoading={this.state.isLoading}
                            callback={this.handleInview}
                            ignoreIndicator={true}
                          />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        {this.props.workForm && !this.props.readOnly && (
          <span className='workschedule__caution'>
            <Tippy
              duration={10}
              distance={24}
              arrow='true'
              arrowType='sharp'
              placement='bottom'
              followCursor={true}
              html={
                <div className='workschedule__caution--tooltip'>
                  協力会社が選択できない場合には、現場体制（施工体系図）画面で対象の協力会社に職長ユーザーを招待してください。
                </div>
              }
            >
              <span className='workschedule--tooltip-text'>
                <QuestionIcon className='icon--2x question-icon' />
                <span> 協力会社が選択肢にない</span>
              </span>
            </Tippy>
          </span>
        )}
        {this.props.otherComponnent ? this.props.otherComponnent : ''}
      </FormElement>
    );
  }
}

/**
 * Tooltipで表示される文字
 * @param data {string}
 */
const renderTooltipContent = data => {
  const rowStyle = {
    maxWidth: '240px',
    wordWrap: 'break-word',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>{data}</div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldTreePartnerCompanyDropdown.jsx